import React from 'react';
import { ClarovideoLogoV2 } from 'components/onboarding/components/ClarovideoLogoV2';
import { OnboardingButton } from 'components/onboarding/components/DefaultButton';

export const LandingHeader = ({ isMobile, texts, onRedirect }) => {
  return (
    <div className="LandingPageV2__Header">
      {isMobile ? (
        <ClarovideoLogoV2 />
      ) : (
        <span className="LandingPageV2__Header__Caption">
          {texts.ALREADY_HAVE_ACCOUNT}
        </span>
      )}
      <OnboardingButton
        textContent={texts.LOGIN}
        size="small"
        variant="primary"
        onClick={() => onRedirect('login')}
      />
    </div>
  );
};
